export default __webpack_public_path__ + "static/media/freecodecamp.ad7d3ade.webp";